import axios from "axios";
import config from "@/config/constants.js";
import { firestore } from "@/config/firebase";

export default {
  namespaced: true,
  state: {
    status: "",
    list_users: [],
    total_actives: 0,
    total_inactives: 0
  },
  mutations: {
    loading(state) {
      state.status = "loading";
    },
    status(state, status) {
      state.status = status;
    },
    success(state) {
      state.status = "";
    },
    addListUser(state, listUser) {
      state.list_users = listUser;
    },
    removeUsers(state) {
      state.list_users = [];
    },
    set_totals_actives(state, actives) {
      state.total_actives = actives;
    },
    set_totals_inactives(state, inactives) {
      state.total_inactives = inactives;
    },
    updateUser(state, data) {
      for (const user of state.list_users) {
        if (user.id === data.id) {
          if (data.url) {
            user.url = data.url;
          }
          if (data.status) {
            user.status = data.status;
          }
          if (data.phone_number) {
            user.phone_number = data.phone_number.substring(2);
            user.phone_number_current = user.phone = user.phone_current = data.phone_number;
          }
          break;
        }
      }
    },
  },
  actions: {
    resend_invite: function ({ commit }, data) {
      commit('loading');
      const users = data.users || [];
      return new Promise(function (resolve) {
        Promise.all(users.map(u =>
          axios.post(config.api_url + 'user/list/send_invite', {
            email: u.email,
            phone_number: u.phone_number,
            name: u.name,
            user_role: 'employee',
          }).then(response => {
            const d = (response && response.data) || {};
            return {
              user: { ...u, phone: u.phone_number },
              email_status: d.email_status || 'unknown',
              email_skip_reason: d.email_skip_reason || null,
              sms_status: d.sms_status || 'unknown',
              sms_skip_reason: d.sms_skip_reason || null,
            };
          }).catch(err => {
            console.error('resend_invite failed for', u.email || u.phone_number, err && err.message);
            return { user: { ...u, phone: u.phone_number }, email_status: 'failed', sms_status: 'failed', error: err && err.message };
          })
        )).then(results => {
          commit('success');
          commit('status', '');
          resolve(results);
        });
      });
    },
    switch_admin: function ({ commit }, user) {
      commit('loading');
      // eslint-disable-next-line no-async-promise-executor
      return new Promise(async function (resolve) {
        try {
          let xuser = {
            user_id: user.id,
            is_admin: !(user.is_admin)
          };

          await axios.post(config.api_url + 'user/list/is_admin', xuser).then(response => {
            resolve(response);
            if (response.status === 200) {
              commit('success');
            }
          });

        } catch (error) {
          commit('status', '');
          console.error(error);
        }
      });
    },
    get_users: async function ({ commit }) {
      let database = firestore;
      commit('loading');
      try {
        let query;
        let list = [];
        const user = localStorage.getItem(config.token_key);
        const parse = JSON.parse(user);
        let vendor_id;

        await axios.post(config.api_url + 'web/retrieve_logged').then(async response => {
          let data = response.data;
          if (parse.user_role === "employee") {
            vendor_id = parse.vendor_id;
          } else {
            vendor_id = data['user_id'];
          }
          if (data['code'] === "SUCCESS") {
            query = await database
              .collection('tenants')
              .doc(data['tenant_id'])
              .collection('users')
              // .where('vendor_id', '==', vendor_id)
              .where('user_role', 'in', ["employee", "vendor"])
              .get()
              .catch((error) => {
                console.error(error);
                commit('status', '');
                return (409).json({ code: config.codes.error });
              });
          }
        });

        if (query) {

          let usersResult = [];
          for (let userRef of query.docs) {
            let user = userRef.data();
            user.id = userRef.id;
            if (user.owner_id === vendor_id) {
              user.is_admin = true;
            }
            if (user.vendor_id === vendor_id || user.owner_id === vendor_id) {
              usersResult.push(user);
            }
          }

          // Batch fetch all global user docs instead of N+1 individual queries
          const ownerIds = [...new Set(usersResult.map(u => u.owner_id))];
          const globalUsersMap = {};
          for (let i = 0; i < ownerIds.length; i += 10) {
            const batch = ownerIds.slice(i, i + 10);
            const batchResult = await database
              .collection('users')
              .where('__name__', 'in', batch)
              .get();
            for (const doc of batchResult.docs) {
              globalUsersMap[doc.id] = doc.data();
            }
          }

          let total_actives = 0;
          let total_inactives = 0;
          for (const user of usersResult) {
            let user_global = globalUsersMap[user.owner_id];
            if (!user_global) continue;

            user_global = { ...user_global };
            delete user_global.first_login;
            delete user_global.has_logged_into_app;
            delete user_global.billing_active;
            delete user_global.is_active;
            delete user_global.status;

            let user_details = user;
            for (let key in user_global) {
              if (key.toLowerCase() === 'status') {
                continue
              }
              user_details[key] = user_global[key];
            }
            user_details['id'] = user.id;
            user_details['name'] = user_details['first_name'] + " " + user_details['last_name'];
            if (user_details['phone_number'] !== undefined) {
              user_details['phone_number'] = user_details['phone_number'].substring(2);
              user_details['phone_number_current'] = user_details['phone_number'].substring(2);
            }
            if (user_details['status'] === 'Active') {
              total_actives += 1;
            } else {
              total_inactives += 1;
            }
            list.push(user_details);
          }

          await commit('set_totals_actives', total_actives);
          await commit('set_totals_inactives', total_inactives);
          await commit('addListUser', list);
          commit('success');
        }

      } catch (error) {
        commit('status', '');
        console.error(error);
      }


    },
    delete: function ({ commit }, info) {
      // eslint-disable-next-line no-async-promise-executor
      return new Promise(async function (resolve) {
        try {
          for (const prop in info.users) {
            commit('loading');
            await axios.post(config.api_url + 'user/me/delete', {
              user_id: info.users[prop].owner_id,
              transfer_id: info.transfer_to,
              transfer_owner: info.transfer_owner
            }).then(async response => {
              if (response.status === 200) {
                commit('success');
              } else {
                commit('status', '');
              }
            });

          }
          resolve(true);
        } catch (error) {
          commit('status', '');
          console.error(error);
        }
      });
    },
    clear_data: async function ({ commit }) {
      commit('removeUsers', true);
    },
    update_phone_number: function ({ commit, state }, data) {
      commit('loading');
      return new Promise(function (resolve) {
        let errorsCounter = null;
        axios.post(config.api_url + 'web/updatePhoneNumberUser', {
          new_phone_number: config.phone_extension + data.new_phone_number,
          phone_number: config.phone_extension + data.phone_number
        }).then(() => {
          let currentUser = state.list_users.find(x => x.owner_id === data.owner_id);
          if (currentUser) {
            commit("updateUser", { id: currentUser.id, phone_number: config.phone_extension + data.new_phone_number });
          }
          commit("success");
          resolve(errorsCounter);
        }).catch((error) => {
          errorsCounter = error.response.data;
          commit("success");
          resolve(errorsCounter);
        });
      });
    },
  }
}
